export class EpsReservationType {
    reservation_type_id: number;
    reservation_types_short_desc: string;
    reservation_types_desc: string;
    reservation_types_code: string;
    reservation_tariffication_type: string;
    sub_type_of_type_id: number;
}